// SB6-ANA-POP-02 — top-level infra mount for the analysis surface (main AND
// pop-out windows). Owns:
//   - `usePopoutWorkspaceStore.hydrate(userId)` once per user-id change, so a
//     freshly-opened pop-out window boots with the workspace state copied into
//     its sessionStorage at open time.
//   - `mountWorkspaceBridge()` so the e2e spec can drive windows without real
//     pop-up windows.
//
// Cross-window synchronisation itself lives in `useWorkspaceSync` (called from
// AnalysisFeature), which runs in every window.
import { useEffect } from "react";
import { useMe } from "@aeriosiq/auth-client";
import {
  mountWorkspaceBridge,
  usePopoutWorkspaceStore,
} from "./popoutWorkspaceStore.js";

export interface PopoutInfraMountProps {
  /** Reserved for future role-based gating of pop-out actions. */
  enabled: boolean;
  /** Reserved — the channel is named per-DA inside `useWorkspaceSync`. */
  inspectionId?: string;
}

export function PopoutInfraMount({
  enabled: _enabled,
  inspectionId: _inspectionId,
}: PopoutInfraMountProps): React.ReactElement | null {
  const me = useMe();
  const userId = me.data?.id ?? "anonymous";
  const hydrate = usePopoutWorkspaceStore((s) => s.hydrate);

  useEffect(() => {
    hydrate(userId);
  }, [hydrate, userId]);

  useEffect(() => mountWorkspaceBridge(), []);

  return null;
}
